import { skipToken, useQuery } from '@tanstack/react-query'
import { useConfig } from 'wagmi'

import { AccountConfig, SavingsBackedByData } from '@/config/chain/types'
import { SimplifiedQueryResult } from '@/domain/common/query'

export interface UseSavingsBackedByChartDataParams {
  chainId: number
  selectedAccountConfig: AccountConfig | undefined
}
export interface UseSavingsBackedByChartDataResult {
  queryResult: SimplifiedQueryResult<SavingsBackedByData>
  shouldDisplayChart: boolean
  groupUsdsDetails: boolean
}

export function useSavingsBackedByChartData({
  chainId,
  selectedAccountConfig,
}: UseSavingsBackedByChartDataParams): UseSavingsBackedByChartDataResult {
  const wagmiConfig = useConfig()
  const backedByResult = selectedAccountConfig?.backedByQueryOptions?.({ chainId, wagmiConfig })
  const skipQueryOptions = {
    queryKey: ['skip'],
    queryFn: skipToken,
  } as const

  const queryResult = useQuery(backedByResult?.queryOptions ?? skipQueryOptions)
  const shouldDisplayChart = backedByResult !== undefined

  return {
    queryResult,
    shouldDisplayChart,
    groupUsdsDetails: !!backedByResult?.groupUsdsDetails,
  }
}
